import { useState } from "react";
import { Col, FormGroup, Label } from "reactstrap";
import styles from "./index.module.scss";

const SelectField = ({ label, options, value, onChange }) => {
    const [isSelectOpen, setIsSelectOpen] = useState(false);

    const handleSelectChange = (e) => onChange(e.target.value);

    // Ensure value is never null - convert to empty string if needed
    const safeValue = value || "";

    return (
        <Col className="px-2 col-12 col-md-6 col-lg-4 ">
            <FormGroup>
                <h5 className="mt-4">
                    <Label className={styles.label}>{label}</Label>
                </h5>
                <div className={`${styles.selectContainer} ${isSelectOpen ? styles.open : ""}`}>
                    <select
                        className={`${styles.select} ${safeValue ? styles.selected : ""}`}
                        value={safeValue}
                        onChange={handleSelectChange}
                        onFocus={() => setIsSelectOpen(true)}
                        onBlur={() => setIsSelectOpen(false)}
                    >
                        <option value="" disabled>Select</option>
                        {options.map((value) => (
                            <option key={value} value={value}>
                                {value}
                            </option>
                        ))}
                    </select>
                </div>
            </FormGroup>
        </Col>
    )
}
export default SelectField